import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ApiError, BaseVisualizacao, BaseVisualizacaoService, DataTablesService, MessageService } from '../../core';
import { ClassificacaoFaturamentoCrudHttpService } from './services';

import { ClassificacaoFaturamento } from './classificacao-faturamento';

@Component({
    selector: 'sgt-classificacao-faturamento',
    templateUrl: './classificacao-faturamento.component.html',
    styleUrls: ['./classificacao-faturamento.component.less']
})
export class ClassificacaoFaturamentoComponent implements BaseVisualizacao<ClassificacaoFaturamento>, OnInit {
    entities: ClassificacaoFaturamento[];
    dataTable: any;

    constructor(private activatedRoute: ActivatedRoute,
                private router: Router,
                private baseVisualizacaoService: BaseVisualizacaoService,
                private messageService: MessageService,
                private dataTablesService: DataTablesService,
                private classificacaoFaturamentoCrudHttpService: ClassificacaoFaturamentoCrudHttpService) { }


    ngOnInit() {
        this.search();
    }

    search() {
        this.classificacaoFaturamentoCrudHttpService.search()
            .subscribe(
                entities => {
                    this.entities = entities;
                    this.showTable();
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as classificações de faturamento', error)
            );
    }

    showTable() {
        this.dataTablesService.showTable('#tableClassificacoesFaturamento', this.dataTable)
            .then(dataTable => {
                this.dataTable = dataTable;
                this.baseVisualizacaoService.ativarArmazenamento(this.dataTable, null);
            });
    }

    insert() {
        this.baseVisualizacaoService.insert(this.activatedRoute);
    }

    edit(entity: ClassificacaoFaturamento) {
        this.baseVisualizacaoService.edit(entity.id, this.activatedRoute);
    }

    delete(entity: ClassificacaoFaturamento) {
        this.messageService.confirm(`Deseja realmente excluir a classificação: ${entity.nome}?`).then(result => {
            if (result) {
                this.classificacaoFaturamentoCrudHttpService.delete(entity.id)
                    .subscribe(
                        response => {
                            this.messageService.success('', response);
                            this.search();
                        },
                        (error: ApiError) => this.messageService.error(error.message, `Erro ao excluir a classificação: ${entity.nome}`, error)
                    );
            }
        });
    }
}
